import './App.css';
import Component1 from './Components/Component1';
import Component2 from './Components/Component2';
import Component3 from './Components/Component3';

function App() {
  return (
    <div className="App">
      {/* <h1>APP COMPONENT</h1> */}
      <Component1/>
    <a href="https://itaxudata.se">
      itaxudata.se</a>
      <Component2/>
      <Component3/>
    </div>
  );
}

export default App;
